module.exports = __webpack_public_path__ + "img/blue-box.b5ef5817.jpg";